const CC = require('cookieconsent');
